import { updateCache } from '@/shared/lib/useCachedQuery';
import { useOnAppReturn } from '@/shared/lib/useOnAppReturn';
import { getCurrentUser } from '../api/userApi';
import { CURRENT_USER_CACHE_KEY } from './useCurrentUser';
import type { CurrentUser } from './types';

/**
 * При возвращении в приложение — тихо перечитать `/me`. Иначе после оплаты
 * (с компа, по ссылке из чата) кеш помнил бы «бесплатные реплики кончились»,
 * и чат показывал бы пейволл до перезапуска. Без скелета: кеш правится на
 * месте, экраны прочтут новое при следующем рендере или входе.
 */
export function useRefreshUserOnReturn(): void {
  useOnAppReturn(() => {
    // Тихо: сбой человек не видит (в кеше прежний профиль), а Safari на
    // iPhone после сворачивания будит сеть не сразу.
    getCurrentUser(undefined, true)
      .then((user) => updateCache<CurrentUser>(CURRENT_USER_CACHE_KEY, () => user))
      .catch(() => {});
  });
}
